// Utilitários de PIN da chamada (geração, validação e rotação por pool)
export const PIN_LENGTH = 6;
export const PIN_POOL_SIZE = 20;

export function isInvalidPin(pin: string): boolean {
  if (pin.length !== PIN_LENGTH) return true;
  const d = pin.split('').map(Number);
  if (d.every(x => x === d[0])) return true; // todos dígitos iguais
  let asc = true, desc = true;
  for (let i = 1; i < d.length; i++) {
    if (d[i] !== d[i-1] + 1) asc = false;
    if (d[i] !== d[i-1] - 1) desc = false;
  }
  if (asc || desc) return true; // sequencial
  return false;
}

export function generateValidPin(): string {
  let attempts = 0;
  while (attempts < 1000) {
    const pin = String(Math.floor(Math.random() * 1000000)).padStart(PIN_LENGTH, '0');
    if (!isInvalidPin(pin)) return pin;
    attempts++;
  }
  return '247813'; // fallback seguro
}

export function buildPinPool(excludePin?: string): string[] {
  const pool: string[] = [];
  const seen = new Set<string>(excludePin ? [excludePin] : []);
  let attempts = 0;
  while (pool.length < PIN_POOL_SIZE && attempts < 5000) {
    const pin = generateValidPin();
    if (!seen.has(pin)) { seen.add(pin); pool.push(pin); }
    attempts++;
  }
  return pool;
}

export function pickPinFromPool(pool: string[], windowIndex: number, prevPin?: string): string {
  if (pool.length === 0) return generateValidPin();
  const idx = windowIndex % pool.length;
  const candidate = pool[idx];
  if (candidate === prevPin) {
    // pula pro próximo slot pra evitar repetição imediata
    const altIdx = (idx + 1) % pool.length;
    return pool[altIdx];
  }
  return candidate;
}
